import React from 'react';
import { ITableViewContext } from 'framework/table/ITableViewContext';
import { INoahDeviceInventoryItemMap, NoahDeviceInventoryItemMapExportProp } from 'gen/ApiClient';
import { SelectableColumn } from '../SelectableColumn';

interface IViewContext extends ITableViewContext<SelectableColumn, INoahDeviceInventoryItemMap> {
	exportRecord: Record<NoahDeviceInventoryItemMapExportProp, string>;
}

export const ViewContext = React.createContext<IViewContext>(undefined as any);
